import { render, staticRenderFns } from "./ToolDetail.vue?vue&type=template&id=604cb431&scoped=true"
import script from "./ToolDetail.vue?vue&type=script&lang=js"
export * from "./ToolDetail.vue?vue&type=script&lang=js"
import style0 from "./ToolDetail.vue?vue&type=style&index=0&id=604cb431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604cb431",
  null
  
)

export default component.exports